import { compose, find, propEq, flatten } from 'ramda';

export default fieldName =>
  compose(
    find(propEq('name', fieldName)),
    flatten
  );
